var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsperma1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "esperma 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.959 2.2779L19.9591 2.27792C26.4535 3.65001 30.6101 10.0366 29.238 16.5437L29.238 16.5438C27.8676 23.0507 21.4901 27.2104 14.9942 25.8383C8.49822 24.4645 4.34319 18.078 5.71357 11.5709C7.08564 5.06548 13.4633 0.904175 19.959 2.2779Z",
    fill: "white",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7268 16.6482C31.1557 9.87158 26.8271 3.21938 20.062 1.7901C19.8572 1.74639 19.654 1.70936 19.4491 1.67578H15.4831C14.6537 1.81031 13.846 2.02723 13.0703 2.31984C14.3548 2.18027 15.6829 2.23746 17.0162 2.51994C23.7829 3.94916 28.1099 10.6014 26.6826 17.378C25.7659 21.7265 22.7032 25.0678 18.8379 26.5273C24.0716 25.9556 28.58 22.0897 29.7268 16.6482Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4769 9.9644C15.6331 13.1257 12.4831 16.4233 9.81838 15.5472C9.45739 15.4294 9.10477 15.1638 8.84954 15.5657C8.33069 16.3846 8.16446 16.852 6.2352 17.0387C3.4261 17.3111 4.98762 19.0246 2.77125 21.0475C1.42799 22.2734 -0.338433 20.9803 0.0561955 20.95C1.02 20.8777 1.31719 20.4842 1.90993 19.9932C3.44127 18.7236 2.192 15.7355 6.03879 15.5993C6.60463 15.5791 7.72629 14.8796 7.97813 14.3852C8.03016 14.2843 7.95124 14.1011 7.9227 14.0388C6.66674 11.2845 10.1978 8.28458 13.917 8.17864C14.9396 8.15005 15.4181 8.79745 15.4769 9.9644Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8298 15.1984C25.0145 18.9248 21.3037 22.8108 18.1638 21.7784C17.739 21.6388 17.3226 21.326 17.022 21.8002C16.4109 22.7654 16.2144 23.3153 13.9409 23.5356C10.6314 23.8551 12.4717 25.8746 9.85902 28.2591C8.27734 29.7035 6.19357 28.18 6.66038 28.1447C7.79546 28.0573 8.14638 27.5949 8.84318 27.0164C10.6499 25.5198 9.17734 22.0004 13.7109 21.8372C14.3758 21.8137 15.6989 20.9914 15.9944 20.4079C16.0549 20.2885 15.9626 20.0733 15.9289 19.9993C14.4497 16.7539 18.6104 13.2193 22.9945 13.0948C24.1967 13.0612 24.7626 13.8246 24.8298 15.1984Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8295 15.1965C24.7623 13.8226 24.1965 13.0592 22.9943 13.0929C22.4587 13.108 21.9264 13.1736 21.4059 13.2846C22.3142 13.4309 22.7508 14.164 22.8112 15.363C22.9489 18.1577 20.8937 21.0449 18.5312 21.8739C21.5871 22.5062 25.0074 18.7782 24.8295 15.1965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9541 15.5892C12.5903 16.3123 15.6294 13.0719 15.4766 9.96446C15.4179 8.79745 14.9393 8.15005 13.9167 8.17864C13.4735 8.19212 13.0302 8.24591 12.5987 8.33503C13.2434 8.52505 13.5574 9.12534 13.6028 10.0569C13.7203 12.4363 11.9657 14.893 9.9541 15.5892Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsperma1);
export default __webpack_public_path__ + "static/media/esperma--1.bb618fc362461ccf9dc83033d65f50fc.svg";
export { ForwardRef as ReactComponent };